import { loadStateFromLocalStorage } from '../../src/redux/utilsLocalStorage'

export const transformSelectedSetup = selSetup => {
  const userPerm = loadStateFromLocalStorage('permissions')
  // If user has 'settings' permission, they see 'name' directly
  if (userPerm.includes('settings')) {
    return selSetup
  }
  // Otherwise, look up the name from alias→name mapping
  const mapping = loadStateFromLocalStorage('setupsMapping') || {}
  return mapping[selSetup] || selSetup
}
